module.exports = __webpack_public_path__ + "img/registration-background.3938f4ce.svg";